import React from 'react';

import withStyles from '@mui/styles/withStyles';

import activityListStyles from '../assets/jss/crm/components/activityListStyles';

import ActivityItem from './ActivityItem';

/* Call with something like:
    <ActivityList
      activityGroups={this.state.activityGroups}
      functionToShowSubject={(activity) => this.functionToShowSubject(activity)}
      rerenderPageFunc={() => this.functionToRerenderPage()}
      page={<somebody that implements buildActivityGroupsFromReduxStore()>}
      contacts={[<list of contacts to show in expanded activity items>]}
      client={<subject>}
    />
*/

class ActivityList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedActivities: [],
    };
  }

  createComponentsForActivityGroup(group) {
    const groupLabel = group.label;
    const { page, contacts, client } = this.props;
    return group.activities.map((activity, i) => (
      <ActivityItem
        key={activity.activityMode + '_' + activity.activityType + '_' + activity.id}
        i={i}
        groupLabel={groupLabel}
        activity={activity}
        functionToShowSubject={this.props.functionToShowSubject}
        rerenderPageFunc={this.props.rerenderPageFunc}
        page={page}
        contacts={contacts}
        client={client}
      />
    ));
  }

  render() {
    const { classes, activityGroups } = this.props;
    if (!activityGroups || activityGroups.length === 0) {
      return null;
    }
    return (
      <div className={classes.activityList}>
        <div className={classes.activityLogList}>
          {activityGroups.map((group) => this.createComponentsForActivityGroup(group))}
        </div>
      </div>
    );
  }
}

export default withStyles(activityListStyles)(ActivityList);
